// https://vuex.vuejs.org/en/actions.html

import NewApiService from "@/utils/new.api.service";

export default {
  index(context, params) {
    const { sortBy, sortDesc, page, itemsPerPage } = params.pagination;
    context.commit("set_loading");

    const sort = [];
    if(sortBy.length){
      for (let idx = 0; idx < sortBy.length; idx++) {
        let s = sortDesc[idx]?'-':'';
        s += sortBy[idx]
        sort.push(s);
      }
    }


    return new Promise((resolve, reject) => {
      context.commit("clear_list");
      NewApiService.get("prescriptions", {
        page: page,
        sort: sort.join(","),
        descending: sortDesc[0],
        rowsPerPage: itemsPerPage,
        search: params.search,
        filter: params.filters
      })
        .then(({ data }) => {
          context.commit("set_prescriptions", data);
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response)
        })
        .finally(() => {
          context.commit("unset_loading");
        })
    });
  },

  delete(context, params) {
    context.commit("set_loading");
    return new Promise((resolve, reject) => {
      NewApiService.delete("prescriptions/" + params.id)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response)
        })
        .finally(() => {
          context.commit("unset_loading");
        })
    });
  },

  add(context, params) {
    context.commit("set_loading");
    return new Promise((resolve, reject) => {
      NewApiService.post("prescriptions", params.model)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response)
        })
        .finally(() => {
          context.commit("unset_loading");
        })
    });
  },

  update(context, params) {
    context.commit("set_loading");
    return new Promise((resolve, reject) => {
      NewApiService.put("prescriptions/" + params.prescriptionId, params.model)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response)
        })
        .finally(() => {
          context.commit("unset_loading");
        })
    });
  },

  get(context, params) {
    context.commit("set_loading");
    return new Promise((resolve, reject) => {
      NewApiService.get("prescriptions/" + params.id)
        .then(({ data }) => {
          resolve(data.prescription);
        })
        .catch(({ response }) => {
          reject(response)
        })
        .finally(() => {
          context.commit("unset_loading");
        })
    });
  },

  print(context, params) {
    context.commit("set_loading");
    return new Promise((resolve, reject) => {
      NewApiService.get("prescriptions/" + params.id + "/print")
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response)
        })
        .finally(() => {
          context.commit("unset_loading");
        })
    });
  },


  quoteAll(context, params) {
    context.commit("set_loading");
    return new Promise((resolve, reject) => {
      NewApiService.put("prescriptions/" + params.id + "/quote-all")
        .then(({ data }) => {
          resolve(data)
        })
        .catch(({ response }) => {
          reject(response)
        })
        .finally(() => {
          context.commit("unset_loading");
        })
    });
  },

  async toggleQuote({dispatch}, item) {
    switch (item.itemType) {
      case 'wood':
        await dispatch('prescriptionWood/quote', item, { root: true})
        break;
      case 'iron':
        await dispatch('prescriptionIron/quote', item, { root: true})
        break;
      case 'wedge':
        await dispatch('prescriptionWedge/quote', item, { root: true})
        break;
      case 'putter':
        await dispatch('prescriptionPutter/quote', item, { root: true})
        break;
      default:
        break;
    }
  },
  

  async deleteItem({dispatch}, item) {
    switch (item.itemType) {
      case 'wood':
        await dispatch('prescriptionWood/delete', item, { root: true})
        break;
      case 'iron':
        await dispatch('prescriptionIron/delete', item, { root: true})
        break;
      case 'wedge':
        await dispatch('prescriptionWedge/delete', item, { root: true})
        break;
      case 'putter':
        await dispatch('prescriptionPutter/delete', item, { root: true})
        break;
      default:
        break;
    }
  },

  duplicate(context, prescriptionId) {
    context.commit("set_loading");
    return new Promise((resolve, reject) => {
      NewApiService.put("prescriptions/" + prescriptionId + "/duplicate")
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response)
        })
        .finally(() => {
          context.commit("unset_loading");
        })
    });
  }
};
